<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <ul class="pad14 size14">
    <li class="flex">
      <p class="width64px">收货人</p>
      <div class="flex1 input">
        <input type="text" placeholder="请填写收货人" v-model="consignee" />
      </div>
    </li>
    <li class="flex">
      <p class="width64px">手机号</p>
      <div class="flex1 input">
        <input type="text" placeholder="请填写收货人手机号" v-model="mobile" />
      </div>
    </li>
    <li class="flex">
      <p class="width64px">所在地区</p>
      <div class="flex1 input">
        <input type="text" placeholder="点击选择" v-model="seladdress" @click="setAddress" />
      </div>
    </li>
    <li class="flex start">
      <p class="width64px mt8">所在地区</p>
      <div class="flex1 input">
        <textarea
          placeholder="如街道、小区、门牌号"
          name=""
          id=""
          rows="5"
          v-model="address"
        ></textarea>
      </div>
    </li>
    <li class="flex between">
      <p>设为默认</p>
      <van-switch class="size18" v-model="checked" />
    </li>

    <van-button round type="primary" block class="mt80" @click="handleAddAddress"
      >保存</van-button
    >
  </ul>
  <van-popup v-model:show="show" round position="bottom">
    <van-cascader
      v-model="cascaderValue"
      title="请选择所在地区"
      :options="addressList"
      @close="show = false"
      :field-names="fieldNames"
      @finish="handleSelectAddress"
    />
  </van-popup>
</template>

<script>
import ajax from "@/utils/request.js";
import { showToast } from 'vant';
export default {
  data() {
    return {
      seladdress: "",
      checked: false,
      show: false,
      consignee: "",
      mobile: "",
      addressList: [],
      cascaderValue: "",
      fieldNames: {
        text: "title",
        value: "id",
        children: "children",
      },
      province: "", //省
      city: "", //市
      district: "", //区
      address: "",
    };
  },
  watch: {},
  methods: {
    next() {
      console.log("下一步");
    },
    setAddress() {
      this.show = true;
    },
    handleSelectAddress(val) {
      this.show = false;
      this.province = val.selectedOptions[0].id;
      this.city = val.selectedOptions[1].id;
      this.district = val.selectedOptions[2].id;
      this.seladdress = `${val.selectedOptions[0].title}/${val.selectedOptions[1].title}/${val.selectedOptions[2].title}`
    },
    handleAddAddress() {
      const data = {
        id: this.$route.query.type? this.$route.query.type === 'edit'?JSON.parse(this.$route.query.addressInfo).id:0 : 0,
        consignee: this.consignee,
        mobile: this.mobile,
        province: this.province,
        city: this.city,
        district: this.district,
        address: this.address,
        is_default: this.checked === false ? 0 : 1,
      };
      ajax.post("users/address",data).then(res => {
        if(res.errcode === 1){
          showToast("添加编辑地址成功")
          setTimeout(() => {
            this.$router.push({path:'/address'})
          },500)
        }
      })
    },
  },
  created() {
    // console.log(this.$route.query.addressInfo)
    // if(this.$route.query.addressInfo) {
    //   this.consignee = this.$route.query.addressInfo.consignee
    //   this.mobile = this.$route.query.addressInfo.moblie
    // }
    try {
      if(this.$route.query.addressInfo) {
        ajax.post("users/addressinfo",{id: JSON.parse(this.$route.query.addressInfo).id}).then(res => {
          this.consignee = res.data.consignee
          this.mobile = res.data.mobile
          this.seladdress = `${res.data.provincestr}/${res.data.citystr}/${res.data.districtstr}`
          this.address = res.data.address
          this.checked = res.data.is_default == 1 ? true : false
          this.province = res.data.province
          this.city = res.data.city
          this.district = res.data.district
        })
      }
    }catch{console.log('err')}

    ajax.post("api/getregionlist").then((res) => {
      this.addressList = res.data.list;
      this.addressList.forEach((item) => {
        if (item.regiontwo) {
          item.children = [...item.regiontwo];
        }
        item.children.forEach((item) => {
          if (item.regionthree) {
            item.children = [...item.regionthree];
          }
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
ul li {
  margin-bottom: 18px;
  .input {
    padding: 0 10px;
    &,
    input,
    textarea {
      background: #fafafa;
      min-height: 32px;
      font-size: 14px;
      resize: none;
      border-radius: 4px;
    }
    textarea {
      padding: 10px 0;
    }
    input,
    textarea {
      width: 100%;
    }
  }
}
</style>
